import { RewardsAction } from './actions';
import {
  API_READ_REWARDS_SUCCESS,
  API_SAVE_REWARDS_OPT_IN_FAILURE,
  API_SAVE_REWARDS_OPT_IN_REQUEST,
  API_SAVE_REWARDS_OPT_IN_SUCCESS,
  API_SAVE_REWARDS_OPT_OUT_REQUEST,
  API_SAVE_REWARDS_OPT_OUT_SUCCESS,
  API_SAVE_REWARDS_OPT_OUT_FAILURE,
} from './actionTypes';
import { Reward, RewardStatus } from './types';

export type RewardsState = {
  isLoading: boolean;
  reward: Reward | null;
};

const initialState = {
  isLoading: false,
  reward: null,
};

export default function rewardsReducer(
  state: RewardsState = initialState,
  action: RewardsAction,
): RewardsState {
  switch (action.type) {
    case API_READ_REWARDS_SUCCESS: {
      return {
        ...state,
        reward: action.payload,
      };
    }
    case API_SAVE_REWARDS_OPT_IN_REQUEST:
    case API_SAVE_REWARDS_OPT_OUT_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case API_SAVE_REWARDS_OPT_IN_SUCCESS: {
      return {
        isLoading: false,
        reward: {
          ...(state.reward as Reward),
          status: RewardStatus.LIVE,
          reward_card_program: {
            created_at: new Date().toISOString(),
            ended_at: null,
            ...action.payload,
          },
        },
      };
    }
    case API_SAVE_REWARDS_OPT_IN_FAILURE:
    case API_SAVE_REWARDS_OPT_OUT_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case API_SAVE_REWARDS_OPT_OUT_SUCCESS: {
      return {
        isLoading: false,
        reward: {
          ...(state.reward as Reward),
          status: RewardStatus.ENDED,
          reward_card_program: {
            ...state.reward!.reward_card_program,
            ended_at: new Date().toISOString(),
          },
        },
      };
    }
    default:
      return state;
  }
}
